// extracted by mini-css-extract-plugin
module.exports = {"containerVideo":"Home_containerVideo__hE0x8","containerVideoActions":"Home_containerVideoActions__7zW_l","cardsRow":"Home_cardsRow__QWAZB"};